import React, { useState, useRef, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Form } from 'semantic-ui-react';
import PaymentSource from './PaymentSource';

const AddPaymentSourceModal = ({ open, onClose, onPaymentSourceAdd, settings, auth, banks, actions, policies }) => {
	const paymentRef = useRef(null);
	const [source, setSource] = useState();
	const [isValid, setIsValid] = useState(false);

	const onCancelClick = useCallback(() => {
		paymentRef.current.reset();
		if (onClose) onClose();
	}, [onClose]);

	const onResetClick = useCallback(() => {
		paymentRef.current.reset();
	}, []);

	const onSourceAdd = useCallback(
		newSource => {
			if (onPaymentSourceAdd) onPaymentSourceAdd(newSource);
			if (onClose) onClose();
		},
		[onClose, onPaymentSourceAdd]
	);

	const onAddClick = useCallback(() => {
		paymentRef.current.add();
	}, []);

	useEffect(() => {
		if (paymentRef.current) {
			var newIsValid = paymentRef.current.isValid();
			setIsValid(newIsValid);
		}
	}, [settings, source]);

	useEffect(() => {
		setSource(null);
	}, [open]);

	return (
		<Modal open={open} onClose={onClose} size='small'>
			<Modal.Header>Add Payment Method</Modal.Header>
			<Modal.Content>
				<Form>
					<PaymentSource ref={paymentRef} source={source} banks={banks} settings={settings} auth={auth} onSourceUpdate={setSource} onSourceAdd={onSourceAdd} actions={actions} policies={policies} />
				</Form>
			</Modal.Content>
			<Modal.Actions>
				<Button onClick={onResetClick} disabled={!source || !(source.type === 'credit' || source.type === 'check')}>
					Reset
				</Button>
				<Button onClick={onCancelClick}>Cancel</Button>
				<Button primary onClick={onAddClick} disabled={!isValid}>
					Add
				</Button>
			</Modal.Actions>
		</Modal>
	);
};

AddPaymentSourceModal.propTypes = {
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func,
	onPaymentSourceAdd: PropTypes.func,
	settings: PropTypes.object.isRequired,
	auth: PropTypes.object.isRequired,
	banks: PropTypes.object.isRequired,
	policies: PropTypes.array.isRequired
};

export default AddPaymentSourceModal;
